import type { AppConfig } from './config';

export const config: AppConfig = {
    FRUITFUL_ENV: process.env.EXPO_PUBLIC_FRUITFUL_ENV,
    API_URL: 'https://api.fruitful.com',
    STYTCH_PUBLIC_TOKEN:
        'public-token-live-484d4ac1-67c8-45f1-ba66-1428a73281a1',
    SENDBIRD_APP_ID: 'E8C8BD08-878B-4D82-9CDF-22A30C1D27CA',
    LOGROCKET_MOBILE_APP_ID: 'um7ghc/fruitful-app-production',
    LOGROCKET_WEB_APP_ID: 'um7ghc/fruitful-rnw-web-app-production',
    SENTRY_DSN_MOBILE:
        'https://17568f15feb0073732356407af207f33@o4505363795738624.ingest.us.sentry.io/4505960026144768',
    SENTRY_DSN_WEB:
        'https://a4ea8ad7f77275209d629e15cafa1c51@o4505363795738624.ingest.us.sentry.io/4507052195840000',
    STATSIG_TOKEN: 'client-xBQUbtXpjmG0gWIX0FMvXwSCqUCDv834AL8KBAu9pnK',
    MIXPANEL_TOKEN: 'df5d8f7cedcfeb4ec843241c27b7f68b', // fruitful-prod project
    INACTIVITY_DURATION: 600000, // 10 minutes
    APPLE_APP_ID: '6469853675',
    QUILTT_CONNECTOR_ID: '8bgg2pfzpc',
    CUSTOMERIO_SITE_ID: '655c86e4113983d0cb1f',
    CUSTOMERIO_RN_WRITE_KEY: '41330ca96d6dc96124ca',
    CUSTOMERIO_WEB_WRITE_KEY: '10b4cac5e32d688f9155',
    LLM_SERVICE_BASE_URL: 'https://llm.fruitful.com',
    STRIPE_PUBLISHABLE_KEY:
        'pk_live_51LNkQgGGy6RMRSOZPOOE4JMpIfDeiSlZFfxjoJwXfGuEKymSDcWplAr57UidvursuvPIofBeK9YxH6vs332gp02J00Q5tkzk8Q',
    // ---- //
};
